import { computed, defineComponent, onMounted, ref } from "vue";
import { gsap, ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);

declare global {
  interface Window {
    assetsFolder?: string;
  }
}

if (undefined === window.assetsFolder) {
  window.assetsFolder = "";
}

export default defineComponent({
  props: {
    type: { type: String, default: "fine-01" },
    parallaxSpeed: { type: Number, default: 0 }, // we stopped using this
    color: { type: String, default: "" },
  },
  setup(props) {
    const texturebackgroundContainer = ref<HTMLElement | null>(null);
    const textureFilename = computed(() => {
      let colorAddition = "";

      switch (props.color) {
        case "white":
        case "blackish":
        case "section-black-background":
          colorAddition = `-${props.color}`;
          break;
        default:
          break;
      }

      switch (props.type) {
        default:
          return window.assetsFolder + "/texture-fine-01.svg";
        case "fine-01":
        case "fine-02":
          return (
            window.assetsFolder + `/texture-${props.type}${colorAddition}.png`
          );

        case "raw-01":
          return (
            window.assetsFolder + `/texture-${props.type}${colorAddition}.svg`
          );
      }
    });
    const textureStyle = computed(() => {
      return {
        "background-image": `url('${textureFilename.value}')`,
      };
    });

    onMounted(() => {
      if (props.parallaxSpeed !== 0) {
        gsap.to(
          texturebackgroundContainer.value!.querySelector(".texturebackground"),
          {
            y: -100 * props.parallaxSpeed,
            duration: 10,
            ease: "none",
            scrollTrigger: {
              scrub: true,
              trigger: texturebackgroundContainer.value,
              start: "top bottom",
              end: "bottom top",
            },
          }
        );
      }
    });

    return { textureFilename, texturebackgroundContainer, textureStyle };
  },
});
